import React from 'react';
import { NotFoundView } from '../../modules/not-found-view/not-found-view';

/**
 * This component should only be used for react-router 404.
 * For application 404, use the NotFoundView component directly.
 */
export const Overview: React.FC = () => {
  return <NotFoundView />;
};
